import KpiChart from "@app/components/kpi-chart";

type Bucket = {
  readonly category: { readonly name: string } | null | undefined;
  readonly points: ReadonlyArray<{
    readonly month: string;
    readonly value: number | null | undefined;
  }>;
};

// Stacks monthly outflows by top-level category. Buckets arrive sparse
// (only months with spend), so each is re-aligned to the shared KPI axis.
export default function CategoryExpensesChart({
  buckets,
  axisMonths,
  onMonthClick,
}: {
  buckets: ReadonlyArray<Bucket>;
  axisMonths: ReadonlyArray<string>;
  onMonthClick: (month: string) => void;
}) {
  if (buckets.length === 0) return null;

  const series = buckets.map((bucket) => {
    const byMonth = new Map(bucket.points.map((p) => [p.month, p.value ?? 0]));

    return {
      name: bucket.category?.name ?? "Uncategorized",
      type: "bar" as const,
      stack: "expenses",
      points: axisMonths.map((month) => ({
        month,
        value: byMonth.get(month) ?? 0,
      })),
    };
  });

  return (
    <KpiChart
      title="Expenses by category (categorize counterparties on the Review page)"
      series={series}
      format="money"
      onMonthClick={onMonthClick}
    />
  );
}
